import { node, object } from 'prop-types';
import { useLayoutEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';

const Portal = ({ children, renderInto }) => {
  const renderContext = useSelector((state) => state.renderContext) ?? {};
  const el = useMemo(() => {
    if (!renderContext.serverSideRendering) {
      return document.createElement('root');
    }
    return null;
  }, [renderContext]);

  const node = useMemo(() => {
    if (!renderContext.serverSideRendering) {
      return renderInto && document.getElementById(renderInto)
        ? document.getElementById(renderInto)
        : document.body;
    }
    return null;
  }, [renderContext]);

  useLayoutEffect(() => {
    if (node && el) {
      node.appendChild(el);
    }
    return () => {
      if (node && el) {
        node.removeChild(el);
      }
    };
  }, [el, node, renderContext]);

  if (!renderContext.serverSideRendering && el !== null) {
    return createPortal(children, el);
  }

  return null;
};

export default Portal;

Portal.propTypes = {
  children: node,
  container: object,
};
